import { render, staticRenderFns } from "./footerBox.vue?vue&type=template&id=73381f48"
import script from "./footerBox.vue?vue&type=script&lang=js"
export * from "./footerBox.vue?vue&type=script&lang=js"
import style0 from "./footerBox.vue?vue&type=style&index=0&id=73381f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports